import { createAction } from "@reduxjs/toolkit";
import {
  CLEAR_LEADS_REPORTS_LEAD,
  RESET_LEADS_REPORTS,
  RESET_LEADS_REPORTS_REPORT_TYPE,
  SELECT_LEADS_REPORTS_LEAD,
  SET_LEADS_REPORTS_DATE_FILTER,
  SET_LEADS_REPORTS_REPORT_TYPE,
} from "../actionTypes";
import { ReportDateFilter, ReportType, SelectedLead } from "src/types/experiences/leadsAndReports";

export const setReportType = createAction<ReportType>(SET_LEADS_REPORTS_REPORT_TYPE);
export const resetReportType = createAction(RESET_LEADS_REPORTS_REPORT_TYPE);
export const setDateFilter = createAction<ReportDateFilter>(SET_LEADS_REPORTS_DATE_FILTER);
export const selectLead = createAction<SelectedLead>(SELECT_LEADS_REPORTS_LEAD);
export const clearSelectedLead = createAction(CLEAR_LEADS_REPORTS_LEAD);
export const resetLeadsAndReports = createAction(RESET_LEADS_REPORTS);
